/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonChangeOfobject,
    JsonChangeOfobjectFromJSON,
    JsonChangeOfobjectFromJSONTyped,
    JsonChangeOfobjectToJSON,
} from './JsonChangeOfobject';

/**
 * 
 * @export
 * @interface JsonEventPartyComp
 */
export interface JsonEventPartyComp {
    /**
     * 
     * @type {Array<string>}
     * @memberof JsonEventPartyComp
     */
    allowedActions?: Array<JsonEventPartyCompAllowedActionsEnum>;
    /**
     * 
     * @type {Array<JsonChangeOfobject>}
     * @memberof JsonEventPartyComp
     */
    changes?: Array<JsonChangeOfobject>;
    /**
     * 
     * @type {number}
     * @memberof JsonEventPartyComp
     */
    compAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonEventPartyComp
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonEventPartyComp
     */
    createdBy?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonEventPartyComp
     */
    eventPartyCompId?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonEventPartyComp
     */
    eventPartyId?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonEventPartyComp
     */
    status?: JsonEventPartyCompStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof JsonEventPartyComp
     */
    tariffId?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonEventPartyComp
     */
    title?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonEventPartyComp
     */
    unitAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonEventPartyComp
     */
    unitCnt?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonEventPartyComp
     */
    updatedAt?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonEventPartyComp
     */
    updatedBy?: number;
}

/**
* @export
* @enum {string}
*/
export enum JsonEventPartyCompAllowedActionsEnum {
    View = 'VIEW',
    Edit = 'EDIT'
}/**
* @export
* @enum {string}
*/
export enum JsonEventPartyCompStatusEnum {
    Deleted = 'DELETED',
    Active = 'ACTIVE',
    Paid = 'PAID'
}

export function JsonEventPartyCompFromJSON(json: any): JsonEventPartyComp {
    return JsonEventPartyCompFromJSONTyped(json, false);
}

export function JsonEventPartyCompFromJSONTyped(json: any, ignoreDiscriminator: boolean): JsonEventPartyComp {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'allowedActions': !exists(json, 'allowedActions') ? undefined : json['allowedActions'],
        'changes': !exists(json, 'changes') ? undefined : ((json['changes'] as Array<any>).map(JsonChangeOfobjectFromJSON)),
        'compAmount': !exists(json, 'compAmount') ? undefined : json['compAmount'],
        'createdAt': !exists(json, 'createdAt') ? undefined : json['createdAt'],
        'createdBy': !exists(json, 'createdBy') ? undefined : json['createdBy'],
        'eventPartyCompId': !exists(json, 'eventPartyCompId') ? undefined : json['eventPartyCompId'],
        'eventPartyId': !exists(json, 'eventPartyId') ? undefined : json['eventPartyId'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'tariffId': !exists(json, 'tariffId') ? undefined : json['tariffId'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'unitAmount': !exists(json, 'unitAmount') ? undefined : json['unitAmount'],
        'unitCnt': !exists(json, 'unitCnt') ? undefined : json['unitCnt'],
        'updatedAt': !exists(json, 'updatedAt') ? undefined : json['updatedAt'],
        'updatedBy': !exists(json, 'updatedBy') ? undefined : json['updatedBy'],
    };
}

export function JsonEventPartyCompToJSON(value?: JsonEventPartyComp | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'allowedActions': value.allowedActions,
        'changes': value.changes === undefined ? undefined : ((value.changes as Array<any>).map(JsonChangeOfobjectToJSON)),
        'compAmount': value.compAmount,
        'createdAt': value.createdAt,
        'createdBy': value.createdBy,
        'eventPartyCompId': value.eventPartyCompId,
        'eventPartyId': value.eventPartyId,
        'status': value.status,
        'tariffId': value.tariffId,
        'title': value.title,
        'unitAmount': value.unitAmount,
        'unitCnt': value.unitCnt,
        'updatedAt': value.updatedAt,
        'updatedBy': value.updatedBy,
    };
}

